//core
import { createSelector } from "@reduxjs/toolkit";

//store
import {RootState} from "../../../index";

// state
const subAffiliateReportV2Selector = (state: RootState) => state.admin.sub_affiliate_report_v2;

const subAffiliateReportV2OptionsSelector = (state: RootState) => state.admin.sub_affiliate_report_v2.options;
const subAffiliateReportV2OptionsDataSelector = (state: RootState) => state.admin.sub_affiliate_report_v2.options.data;
const subAffiliateReportV2OptionsErrorSelector = (state: RootState) => state.admin.sub_affiliate_report_v2.options.error;
const subAffiliateReportV2OptionsFetchingSelector = (state: RootState) => state.admin.sub_affiliate_report_v2.options.isFetching;

const subAffiliateReportV2ListSelector = (state: RootState) => state.admin.sub_affiliate_report_v2.list;
const subAffiliateReportV2ListDataSelector = (state: RootState) => state.admin.sub_affiliate_report_v2.list.data;
const subAffiliateReportV2ListErrorSelector = (state: RootState) => state.admin.sub_affiliate_report_v2.list.error;
const subAffiliateReportV2ListFetchingSelector = (state: RootState) => state.admin.sub_affiliate_report_v2.list.isFetching;

const subAffiliateReportV2DownloadSelector = (state: RootState) => state.admin.sub_affiliate_report_v2.download;
const subAffiliateReportV2DownloadDataSelector = (state: RootState) => state.admin.sub_affiliate_report_v2.download.data;
const subAffiliateReportV2DownloadErrorSelector = (state: RootState) => state.admin.sub_affiliate_report_v2.download.error;
const subAffiliateReportV2DownloadFetchingSelector = (state: RootState) => state.admin.sub_affiliate_report_v2.download.isFetching;

const subAffiliateReportV2DealsSelector = (state: RootState) => state.admin.sub_affiliate_report_v2.deals;
const subAffiliateReportV2DealsDataSelector = (state: RootState) => state.admin.sub_affiliate_report_v2.deals.data;
const subAffiliateReportV2DealsErrorSelector = (state: RootState) => state.admin.sub_affiliate_report_v2.deals.error;
const subAffiliateReportV2DealsFetchingSelector = (state: RootState) => state.admin.sub_affiliate_report_v2.deals.isFetching;

const subAffiliateReportV2ProductsSelector = (state: RootState) => state.admin.sub_affiliate_report_v2.products;
const subAffiliateReportV2ProductsDataSelector = (state: RootState) => state.admin.sub_affiliate_report_v2.products.data;
const subAffiliateReportV2ProductsErrorSelector = (state: RootState) => state.admin.sub_affiliate_report_v2.products.error;
const subAffiliateReportV2ProductsFetchingSelector = (state: RootState) => state.admin.sub_affiliate_report_v2.products.isFetching;

const subAffiliateReportV2BrandsSelector = (state: RootState) => state.admin.sub_affiliate_report_v2.brands;
const subAffiliateReportV2BrandsDataSelector = (state: RootState) => state.admin.sub_affiliate_report_v2.brands.data;
const subAffiliateReportV2BrandsErrorSelector = (state: RootState) => state.admin.sub_affiliate_report_v2.brands.error;
const subAffiliateReportV2BrandsFetchingSelector = (state: RootState) => state.admin.sub_affiliate_report_v2.brands.isFetching;

const subAffiliateReportV2CurrenciesSelector = (state: RootState) => state.admin.sub_affiliate_report_v2.currencies;
const subAffiliateReportV2CurrenciesDataSelector = (state: RootState) => state.admin.sub_affiliate_report_v2.currencies.data;
const subAffiliateReportV2CurrenciesErrorSelector = (state: RootState) => state.admin.sub_affiliate_report_v2.currencies.error;
const subAffiliateReportV2CurrenciesFetchingSelector = (state: RootState) => state.admin.sub_affiliate_report_v2.currencies.isFetching;

const subAffiliateReportV2PlatformsSelector = (state: RootState) => state.admin.sub_affiliate_report_v2.platforms;
const subAffiliateReportV2PlatformsDataSelector = (state: RootState) => state.admin.sub_affiliate_report_v2.platforms.data;
const subAffiliateReportV2PlatformsErrorSelector = (state: RootState) => state.admin.sub_affiliate_report_v2.platforms.error;
const subAffiliateReportV2PlatformsFetchingSelector = (state: RootState) => state.admin.sub_affiliate_report_v2.platforms.isFetching;

const subAffiliateReportV2ColumnsDataSelector = (state: RootState) => state.admin.sub_affiliate_report_v2.columns.data;
const subAffiliateReportV2ColumnsErrorSelector = (state: RootState) => state.admin.sub_affiliate_report_v2.columns.error;
const subAffiliateReportV2ColumnsFetchingSelector = (state: RootState) => state.admin.sub_affiliate_report_v2.columns.isFetching;

//selectors
export const selectSubAffiliateReportV2 = createSelector(subAffiliateReportV2Selector, (report) => report);

export const selectOptions = createSelector(subAffiliateReportV2OptionsSelector, (options) => options);
export const selectOptionsData = createSelector(subAffiliateReportV2OptionsDataSelector, (data) => data);
export const selectOptionsError = createSelector(subAffiliateReportV2OptionsErrorSelector, (error) => error);
export const selectOptionsIsFetching = createSelector(subAffiliateReportV2OptionsFetchingSelector, (isFetching) => isFetching);

//columns
export const selectColumnsData = createSelector(subAffiliateReportV2ColumnsDataSelector, (data) => data);
export const selectColumnsError = createSelector(subAffiliateReportV2ColumnsErrorSelector, (error) => error);
export const selectColumnsIsFetching = createSelector(subAffiliateReportV2ColumnsFetchingSelector, (isFetching) => isFetching);

export const selectList = createSelector(subAffiliateReportV2ListSelector, (list) => list);
export const selectListDataColumnsSort = createSelector(subAffiliateReportV2ListDataSelector, (data) => data?.columns.filter((el: any) => el.sort === true));
const columnsFloat = [
  'poker_rake_sum',
  'poker_bonus',
  'ngr_poker',
  'poker_revenue_share_profit',
  'pkm_casino_bet_sum',
  'pkm_casino_ggr',
  'pkm_casino_bonus',
  'ngr_pkm_casino',
  'pkm_casino_revenue_share_profit',
];
export const selectListData = createSelector(subAffiliateReportV2ListDataSelector, (data) => {
  if (!!data) {

    const columns = data.columns.map((item: any) => {
      if (item.name === 'affiliateLevel') {
        return { ...item, type: 'int_with_zero' };
      }

      return item;
    });

    return { ...data, columns: columns };
  } else {
    return data;
  }
});
export const selectListError = createSelector(subAffiliateReportV2ListErrorSelector, (error) => error);
export const selectListIsFetching = createSelector(subAffiliateReportV2ListFetchingSelector, (isFetching) => isFetching);

export const selectDownload = createSelector(subAffiliateReportV2DownloadSelector, (data) => data);
export const selectDownloadData = createSelector(subAffiliateReportV2DownloadDataSelector, (data) => data);
export const selectDownloadError = createSelector(subAffiliateReportV2DownloadErrorSelector, (error) => error);
export const selectDownloadIsFetching = createSelector(subAffiliateReportV2DownloadFetchingSelector, (isFetching) => isFetching);

export const selectDeals = createSelector(subAffiliateReportV2DealsSelector, (data) => data);
export const selectDealsData = createSelector(subAffiliateReportV2DealsDataSelector, (data) => data);
export const selectDealsError = createSelector(subAffiliateReportV2DealsErrorSelector, (error) => error);
export const selectDealsIsFetching = createSelector(subAffiliateReportV2DealsFetchingSelector, (isFetching) => isFetching);

export const selectProducts = createSelector(subAffiliateReportV2ProductsSelector, (data) => data);
export const selectProductsData = createSelector(subAffiliateReportV2ProductsDataSelector, (data) => data);
export const selectProductsError = createSelector(subAffiliateReportV2ProductsErrorSelector, (error) => error);
export const selectProductsIsFetching = createSelector(subAffiliateReportV2ProductsFetchingSelector, (isFetching) => isFetching);

export const selectBrands = createSelector(subAffiliateReportV2BrandsSelector, (data) => data);
export const selectBrandsData = createSelector(subAffiliateReportV2BrandsDataSelector, (data) => data);
export const selectBrandsError = createSelector(subAffiliateReportV2BrandsErrorSelector, (error) => error);
export const selectBrandsIsFetching = createSelector(subAffiliateReportV2BrandsFetchingSelector, (isFetching) => isFetching);

export const selectCurrencies = createSelector(subAffiliateReportV2CurrenciesSelector, (data) => data);
export const selectCurrenciesData = createSelector(subAffiliateReportV2CurrenciesDataSelector, (data) => data);
export const selectCurrenciesError = createSelector(subAffiliateReportV2CurrenciesErrorSelector, (error) => error);
export const selectCurrenciesIsFetching = createSelector(subAffiliateReportV2CurrenciesFetchingSelector, (isFetching) => isFetching);

export const selectPlatforms = createSelector(subAffiliateReportV2PlatformsSelector, (data) => data);
export const selectPlatformsData = createSelector(subAffiliateReportV2PlatformsDataSelector, (data) => data);
export const selectPlatformsError = createSelector(subAffiliateReportV2PlatformsErrorSelector, (error) => error);
export const selectPlatformsIsFetching = createSelector(subAffiliateReportV2PlatformsFetchingSelector, (isFetching) => isFetching);
